import { ChevronRight } from "lucide-react";
import Button from "../../../../../../../components/shared/Button";
import { useGroupCollapse } from "../../../../hooks/grid/useGroupCollapse";
import { getGroupRowStyle } from "../../../../helpers/grid/getGroupRowStyle";
import { cn } from "../../../../../../../lib/utils";

function GroupByCell({ style, value, withDivider }: any) {
    const { isCollapsed, toggleGroup } = useGroupCollapse();

    const expand = !isCollapsed(value.originalId);

    return (
        <div
            style={{ ...style, ...getGroupRowStyle(withDivider) }}
            className="employee-info-cell tw-flex tw-items-center tw-px-3 tw-gap-2 tw-w-full"
        >
            <Button
                // size="xs"
                variant="ghost"
                onClick={() => toggleGroup(value.originalId)}
                className="tw-flex tw-items-center tw-justify-center tw-w-5 tw-h-5 tw-rounded hover:tw-bg-primary/20 tw-transition-colors tw-shrink-0"
            >
                <ChevronRight
                    size={14}
                    className={cn("tw-text-primary tw-transition-transform tw-duration-200", expand && "tw-rotate-90")}
                />
            </Button>
            <span className="tw-flex-1 tw-text-sm tw-font-semibold tw-text-primary tw-truncate">{value.name}</span>
        </div>
    );
}

export default GroupByCell;
